import React, { useState, useLayoutEffect } from 'react';

import { EVENT_CONTROL } from '../../../../data/StateValues';

import EmployeeEventAdd from './EventAdd';

import { Fade } from 'react-reveal';
import EventEdit from './EventEdit';




function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

function sortByDate(events) {
    events.sort(function (a, b) {
        var partsA = a.date.split('/'),
            partsB = b.date.split('/');

        var dateA = new Date(partsA[2], partsA[0] - 1, partsA[1]); // Month is 0-indexed
        var dateB = new Date(partsB[2], partsB[0] - 1, partsB[1]);

        return dateA - dateB;
    });
    return events;
}

function EventControl(props) {
    // Local State for Events
    const [events, setEvents] = useState(sortByDate(props.events).reverse());

    const [width, height] = useWindowSize();
    const [showing, setShowing] = useState(EVENT_CONTROL.nothing);
    const [opened, setOpened] = useState("");
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [editing, setEditing] = useState(false);

    // Update Events
    const updateEvents = (newEvent) => {
        // Update Parent State
        props.setEvents((prevEvents) =>
            prevEvents.map((event) =>
                event._id === newEvent._id ? newEvent : event
            )
        );

        // Update Local State
        setEvents((prevEvents) =>
            prevEvents.map((event) =>
                event._id === newEvent._id ? newEvent : event
            )
        );
    };

    // Events

    const onActiveClick = () => {
        if (props.upcomingEvents !== 0) {
            if (showing !== EVENT_CONTROL.active) {
                setShowing(EVENT_CONTROL.active);
                setOpened("");
            } else {
                setShowing(EVENT_CONTROL.nothing);
            }
        }
    }

    const onInactiveClick = () => {
        if (showing !== EVENT_CONTROL.inactive) {
            setShowing(EVENT_CONTROL.inactive);
            setOpened("");
        } else {
            setShowing(EVENT_CONTROL.nothing);
        }

    }

    const onArchivedClick = () => {
        if (showing !== EVENT_CONTROL.archived) {
            setShowing(EVENT_CONTROL.archived);
            setOpened("");
        } else {
            setShowing(EVENT_CONTROL.nothing);
        }

    }

    const onAllClick = () => {
        if (showing !== EVENT_CONTROL.all) {
            setShowing(EVENT_CONTROL.all);
            setOpened("");
        } else {
            setShowing(EVENT_CONTROL.nothing);
        }

    }

    const onAddClick = () => {
        if (showing !== EVENT_CONTROL.add) {
            setShowing(EVENT_CONTROL.add);
            setOpened("");
        } else {
            setShowing(EVENT_CONTROL.nothing);
        }

    }

    const onEditEventClick = (event) => {
        setSelectedEvent(event);
        setEditing(true);
        setOpened("");
    }

    const onEventClick = (id) => {
        setOpened(id);
    }



    // Renders

    const renderControl = () => {
        if (width <= 1450) {
            return (
                <>
                    <div className='mobile-event-control-row-1'>
                        <button className={props.upcomingEvents !== 0 ?
                            showing === EVENT_CONTROL.active ? 'approved-button-selected' : 'approved-button'
                            : 'disabled-button'}
                            onClick={onActiveClick}>
                            View Active Events
                        </button>

                        <button className={showing === EVENT_CONTROL.inactive ? 'pending-button-selected' : 'pending-button'}
                            onClick={onInactiveClick}>
                            View Inactive Events
                        </button>

                        <button className={showing === EVENT_CONTROL.archived ? 'denied-button-selected' : 'denied-button'}
                            onClick={onArchivedClick}>
                            View Archived Events
                        </button>
                    </div>
                    <div className='mobile-event-control-row-2'>
                        <button className={showing === EVENT_CONTROL.all ? 'all-button-selected' : 'all-button'}
                            onClick={onAllClick}>
                            View All Events
                        </button>

                        <button className={showing === EVENT_CONTROL.add ? 'search-button-selected' : 'search-button'}
                            onClick={onAddClick}>
                            Add Event
                        </button>
                    </div>
                </>
            )
        }

        return (
            <div className='event-control'>
                <div className='control-items'>
                <button className={props.upcomingEvents !== 0 ?
                            showing === EVENT_CONTROL.active ? 'approved-button-selected' : 'approved-button'
                            : 'disabled-button'}
                        onClick={onActiveClick}>
                        View Active Events
                    </button>

                    <button className={showing === EVENT_CONTROL.inactive ? 'pending-button-selected' : 'pending-button'}
                        onClick={onInactiveClick}>
                        View Inactive Events
                    </button>

                    <button className={showing === EVENT_CONTROL.archived ? 'denied-button-selected' : 'denied-button'}
                        onClick={onArchivedClick}>
                        View Archived Events
                    </button>

                    <button className={showing === EVENT_CONTROL.all ? 'all-button-selected' : 'all-button'}
                        onClick={onAllClick}>
                        View All Events
                    </button>
                </div>

                <div className='add-event-button-container'>
                    <button className={showing === EVENT_CONTROL.add ? 'search-button-selected' : 'search-button'}
                        onClick={onAddClick}>
                        Add Event
                    </button>
                </div>
            </div>
        )
    }


    const renderEventItem = (item) => {
        if (opened === item._id) {
            return (
                <>
                    <li className='application-container'>
                        <button className={item.archived ? "application denied" : item.active ? "application approved" : "application pending"}
                            onClick={() => onEventClick('')}>
                            <i class="fa-solid fa-angle-down" />
                            {item.name} | {item.date} | {item.attending} Attending | {item.active ? "Ongoing Event" : "Past Event"}
                        </button>

                        <div className='application-info-list'>
                            <div className='application-info-item'>
                                <h2>Event Name: </h2> <p>{item.name}</p>
                            </div>

                            <div className='application-info-item'>
                                <h2>Event Date: </h2> <p>{item.date}</p>
                            </div>

                            <div className='application-info-item'>
                                <h2>Event Location: </h2> <p>{item.location}</p>
                            </div>

                            <div className='application-info-item'>
                                <h2>Event Added on: </h2> <p>{item.dateAdded}</p>
                            </div>

                            <div className='application-info-item'>
                                <h2>Event Images: </h2> <p>{item.images.length}</p>
                            </div>

                        </div>


                        <div className='description-container'>
                            <h2>Event Description</h2>
                            <p>{item.description}</p>
                        </div>

                        <div>
                            <button className='view-full-button approved-button' onClick={() => onEditEventClick(item)} >
                                View / Change Details
                            </button>
                        </div>

                    </li>

                </>
            )
        } else {
            return (
                <li className='application-container' key={item.token}>
                    <button className={item.archived ? "application denied" : item.active ? "application approved" : "application pending"}
                        onClick={() => onEventClick(item._id)}>
                        <i class="fa-solid fa-angle-right" />
                        {item.name} | {item.date} | {item.attending} Attending | {item.active ? "Ongoing Event" : "Past Event"}
                    </button>
                </li>
            )

        }
    }

    const renderEventsDisplay = () => {
        switch (showing) {
            case EVENT_CONTROL.nothing:
                if (!events) {
                    return (
                        <>
                            <div>
                                <h2>No Events Here!</h2>
                                <p>Let's add one soon!</p>
                            </div>
                        </>
                    )
                }
                break;

            case EVENT_CONTROL.all:
                return (
                    <>
                        <ul className='applications-list'>
                            <div className='applications-list-padding'>
                                {events.map((item, index) => {
                                    return (
                                        <Fade>
                                            {renderEventItem(item)}
                                        </Fade>
                                    )
                                })}
                            </div>
                        </ul>
                    </>
                )

            case EVENT_CONTROL.active:
                return (
                    <>
                        <ul className='applications-list'>
                            <div className='applications-list-padding'>
                                {events.map((item, index) => {
                                    if (item.active && !item.archived) {
                                        return (
                                            <Fade>
                                                {renderEventItem(item)}
                                            </Fade>
                                        )
                                    }
                                })}
                            </div>
                        </ul>
                    </>
                )

            case EVENT_CONTROL.inactive:
                return (
                    <>
                        <ul className='applications-list'>
                            <div className='applications-list-padding'>
                                {events.map((item, index) => {
                                    if (!item.active && !item.archived) {
                                        return (
                                            <Fade>
                                                {renderEventItem(item)}
                                            </Fade>
                                        )
                                    }
                                })}
                            </div>
                        </ul>
                    </>
                )

            case EVENT_CONTROL.add:
                return <EmployeeEventAdd />;

            case EVENT_CONTROL.archived:
                return (
                    <ul className='applications-list'>
                        <div className='applications-list-padding'>
                            {events.map((item, index) => {
                                if (item.archived) {
                                    return (
                                        <Fade>
                                            {renderEventItem(item)}
                                        </Fade>
                                    )
                                }
                            })}
                        </div>
                    </ul>
                )
        }

    }

    if (editing && selectedEvent !== null) {
        return <EventEdit setEditing={setEditing} event={selectedEvent} updateEvents={updateEvents} />
    }

    return (
        <>
            <div className='display-container'>
                <h1 className='header'>Events</h1>
                {renderControl()}
                {renderEventsDisplay()}
            </div>
        </>
    )
}

export default EventControl;